/**
 * Локали кабинета агента v2 (DEV-1021): материалы ЖК для клиента, комментарии по
 * клиенту/сделке (drawer) и постановка задачи по свободным слотам куратора.
 * Модульный словарь — подмешивается в agents.cabinet.* поверх базовых локалей
 * (см. locales/index.ts), чтобы не править монолитные ru/en/vn.ts.
 */

const ru = {
  agents: {
    cabinet: {
      materials: {
        empty: 'Материалы появятся здесь, когда менеджер VINPROP их загрузит.',
        download: 'Скачать',
        categories: {
          presentation: 'Презентация',
          brochure: 'Брошюра',
          price_list: 'Прайс-лист',
          floor_plan: 'Поэтажные планы',
          documents: 'Документы',
          creative: 'Креатив',
        },
      },
      comments: {
        open: 'Комментарии',
        dealTitle: 'Комментарии по сделке',
        clientTitle: 'Комментарии по клиенту',
        dealNote: 'Здесь только ваши комментарии — менеджер VINPROP видит их в карточке сделки.',
        clientNote: 'Здесь только ваши комментарии — менеджер VINPROP видит их в карточке клиента.',
        authorAgent: 'Вы · агент',
        placeholder: 'Напишите комментарий…',
        send: 'Отправить',
        empty: 'Пока нет комментариев',
        loading: 'Загрузка…',
        sendError: 'Не удалось отправить комментарий',
        loadError: 'Не удалось загрузить комментарии',
      },
      taskModal: {
        open: 'Поставить задачу',
        title: 'Поставить задачу менеджеру',
        note: 'Показаны только свободные окна куратора — содержимое его календаря вам не видно.',
        dateLabel: 'Дата',
        slotsLabel: 'Свободные слоты',
        slotsMeta: 'Свободных окон: {count} · {min} мин',
        descriptionLabel: 'Тема задачи',
        descriptionPlaceholder: 'Например: перезвонить клиенту, назначить показ',
        reminderLabel: 'Напоминание',
        reminderNone: 'Без напоминания',
        reminder15: 'За 15 минут',
        reminder30: 'За 30 минут',
        reminder60: 'За 1 час',
        submit: 'Создать задачу',
        cancel: 'Отмена',
        loadingSlots: 'Загрузка слотов…',
        noSlots: 'Свободных окон пока нет — попробуйте позже',
        slotTaken: 'Слот уже занят, выберите другой',
        success: 'Задача создана',
        createError: 'Не удалось создать задачу',
        loadError: 'Не удалось загрузить свободные слоты',
      },
    },
  },
}

const en = {
  agents: {
    cabinet: {
      materials: {
        empty: 'Materials will appear here once your VINPROP manager uploads them.',
        download: 'Download',
        categories: {
          presentation: 'Presentation',
          brochure: 'Brochure',
          price_list: 'Price list',
          floor_plan: 'Floor plans',
          documents: 'Documents',
          creative: 'Creative',
        },
      },
      comments: {
        open: 'Comments',
        dealTitle: 'Deal comments',
        clientTitle: 'Client comments',
        dealNote: 'Only your comments — the VINPROP manager sees them on the deal card.',
        clientNote: 'Only your comments — the VINPROP manager sees them on the client card.',
        authorAgent: 'You · agent',
        placeholder: 'Write a comment…',
        send: 'Send',
        empty: 'No comments yet',
        loading: 'Loading…',
        sendError: 'Failed to send the comment',
        loadError: 'Failed to load comments',
      },
      taskModal: {
        open: 'Create task',
        title: 'Create a task for the manager',
        note: "Only the curator's free windows are shown — their calendar itself is hidden.",
        dateLabel: 'Date',
        slotsLabel: 'Free slots',
        slotsMeta: 'Free windows: {count} · {min} min',
        descriptionLabel: 'Task subject',
        descriptionPlaceholder: 'e.g. call the client, schedule a viewing',
        reminderLabel: 'Reminder',
        reminderNone: 'No reminder',
        reminder15: '15 minutes before',
        reminder30: '30 minutes before',
        reminder60: '1 hour before',
        submit: 'Create task',
        cancel: 'Cancel',
        loadingSlots: 'Loading slots…',
        noSlots: 'No free windows yet — try again later',
        slotTaken: 'This slot is already taken, pick another',
        success: 'Task created',
        createError: 'Failed to create the task',
        loadError: 'Failed to load free slots',
      },
    },
  },
}

const vn = {
  agents: {
    cabinet: {
      materials: {
        empty: 'Tài liệu sẽ xuất hiện ở đây khi quản lý VINPROP tải lên.',
        download: 'Tải xuống',
        categories: {
          presentation: 'Bài thuyết trình',
          brochure: 'Tờ rơi',
          price_list: 'Bảng giá',
          floor_plan: 'Mặt bằng tầng',
          documents: 'Tài liệu',
          creative: 'Ấn phẩm quảng cáo',
        },
      },
      comments: {
        open: 'Bình luận',
        dealTitle: 'Bình luận giao dịch',
        clientTitle: 'Bình luận khách hàng',
        dealNote: 'Chỉ bình luận của bạn — quản lý VINPROP thấy chúng trên thẻ giao dịch.',
        clientNote: 'Chỉ bình luận của bạn — quản lý VINPROP thấy chúng trên thẻ khách hàng.',
        authorAgent: 'Bạn · đại lý',
        placeholder: 'Viết bình luận…',
        send: 'Gửi',
        empty: 'Chưa có bình luận',
        loading: 'Đang tải…',
        sendError: 'Không gửi được bình luận',
        loadError: 'Không tải được bình luận',
      },
      taskModal: {
        open: 'Giao nhiệm vụ',
        title: 'Giao nhiệm vụ cho quản lý',
        note: 'Chỉ hiển thị khung giờ trống của điều phối viên — lịch của họ không hiển thị.',
        dateLabel: 'Ngày',
        slotsLabel: 'Khung giờ trống',
        slotsMeta: 'Khung trống: {count} · {min} phút',
        descriptionLabel: 'Chủ đề nhiệm vụ',
        descriptionPlaceholder: 'Ví dụ: gọi lại khách, đặt lịch xem nhà',
        reminderLabel: 'Nhắc nhở',
        reminderNone: 'Không nhắc',
        reminder15: 'Trước 15 phút',
        reminder30: 'Trước 30 phút',
        reminder60: 'Trước 1 giờ',
        submit: 'Tạo nhiệm vụ',
        cancel: 'Hủy',
        loadingSlots: 'Đang tải khung giờ…',
        noSlots: 'Chưa có khung giờ trống — thử lại sau',
        slotTaken: 'Khung giờ đã được đặt, hãy chọn khung khác',
        success: 'Đã tạo nhiệm vụ',
        createError: 'Không tạo được nhiệm vụ',
        loadError: 'Không tải được khung giờ trống',
      },
    },
  },
}

export const agentCabinetMessages = { ru, en, vn }
